import React, { useContext, useEffect, useState } from "react";
import {
  Card,
  CardContent,
  Typography,
} from "@material-ui/core";
import EmployeeStepsContext from "../../../hooks/EmployeeStepsContext";
import AuthContext from "../../../hooks/authContext";
import styles from "../employee.module.scss";
import DialogComponent from "../../../components/DialogComponent/DialogComponent";
import ConfirmCancel from "../../../components/DialogComponent/ConfirmCancel";
import { useMediaQuery } from "@mui/material";
import { Input } from "../../../components/ui/input";
import SingleSelectNew from "../../../components/SelectField/SingleSelectNew";
import { Button } from "../../../components/ui/button";
const StepProfile = (props) => {
  const stepsContext = useContext(EmployeeStepsContext);
  const auth = useContext(AuthContext);
  const [companyDetails, setCompanyDetails] = useState([]);
  const {
    handleInputChange,
    handleSingleSelectChange,
    companyEmployee,
    onCancelAll,
    finalLoading,
    isEdit,
    stepFormValues, 
    stepFormErrors,
    editData
  } = props;


  const selectedValues = [
    { label: "EDT - Eastern", value: "America/New_York" },
    { label: "CDT - Central", value: "America/Chicago" },
    { label: "MDT - Mountain", value: "America/Denver" },
    { label: "PDT - Pacific", value: "America/Los_Angeles" },
  ];
  const isMobile = useMediaQuery('(max-width:767px)');

  // const getAllEmployeeData = () => {
  //   getAllEmployee((res) => {
  //     if (res) {
  //       const data = res?.data?.filter((item) => item.role === "companyUser");
  //       const companyNames = data.map((res) => ({
  //         value: res?.id,
  //         label: `${res?.firstName} ${res?.lastName}`,
  //         name: `${res?.firstName} ${res?.lastName}`,
  //         firstName: res?.firstName,
  //         lastName: res?.lastName,
  //       }));
  //       setCompanyDetails(companyNames);
  //     } else {
  //       setCompanyDetails([]);
  //     }
  //   });
  // };

  // useEffect(() => {
  //   getAllEmployeeData();
  // }, []);

  return (
    <>
      <Card className={`${styles.cardProfile} dark:bg-[#1A1F2C] shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)]`}>
        <CardContent className="p-24">
          <h5
            className="stepSectionTitle mb-30 mt-0 text-foreground"
            style={{ fontSize: "24px", fontWeight:"500" }}
          >
            Personal Information
          </h5>
          <div className="stepSectionContent">
            <div className={isMobile ? "d-flex flex-direction-column" :"d-flex flex-center flex-space-between"}>
              <div className="formFieldwrap">
                <Typography variant="body" className={`${styles.labelSm} dark:text-white`}>
                  First Name
                </Typography>
                <div className="w-100">
                  <Input
                    id="firstName"
                    name="firstName"
                    style={{ width: isMobile ? "" :"400px" }}
                    placeholder="First Name *"
                    onChange={handleInputChange}
                    value={
                      stepFormValues?.firstName ? stepFormValues?.firstName : ""
                    }
                  />
                </div>
                {typeof stepFormErrors?.firstName !== "undefined" &&
                  stepFormErrors?.firstName !== "" && (
                    <span className="small error color-danger">
                      {stepFormErrors?.firstName}
                    </span>
                  )}
              </div>
              <div className="formFieldwrap">
                <Typography variant="body" className={`${styles.labelSm} dark:text-white`}>
                  Last Name
                </Typography>
                <div className="w-100">
                  <Input
                    name="lastName"
                    id="lastName"
                    style={{ width: isMobile ? "" :"400px" }}
                    placeholder="Last Name *"
                    onChange={handleInputChange}
                    value={
                      stepFormValues?.lastName ? stepFormValues?.lastName : ""
                    }
                  />
                </div>

                {typeof stepFormErrors?.lastName !== "undefined" &&
                  stepFormErrors?.lastName !== "" && (
                    <span className="small error color-danger">
                      {stepFormErrors?.lastName}
                    </span>
                  )}
              </div>
            </div>
            <div className="formFieldwrap w-50">
              <Typography variant="body" className={`${styles.labelSm} dark:text-white`}>
                Mobile
              </Typography>
              <div>
                <Input
                  id="phoneNumber"
                  name="phoneNumber"
                  placeholder="Mobile *"
                  onChange={handleInputChange}
                  value={
                    stepFormValues?.phoneNumber
                      ? stepFormValues?.phoneNumber
                      : ""
                  }
                />
              </div>
              {typeof stepFormErrors?.phoneNumber !== "undefined" &&
                stepFormErrors?.phoneNumber !== "" && (
                  <span className="small error color-danger">
                    {stepFormErrors?.phoneNumber}
                  </span>
                )}
            </div>
            <div className="formFieldwrap">
              <Typography variant="body" className={`${styles.labelSm} dark:text-white`}>
                Email
              </Typography>
              <div>
                <Input
                  id="email"
                  name="email"
                  placeholder="Email"
                  onChange={handleInputChange}
                  value={stepFormValues?.email ? stepFormValues?.email : ""}
                />
              </div>
              {typeof stepFormErrors?.email !== "undefined" &&
                stepFormErrors?.email !== "" && (
                  <span className="small error color-danger">
                    {stepFormErrors?.email}
                  </span>
                )}
            </div>
            {/* {auth?.userProfile?.role === "superUser" ? (
              <div className="formFieldwrap">
                <SingleSelectNew
                  id="companyId"
                  placeholder="Company *"
                  onChange={handleSingleSelectChange("companyId")}
                  value={
                    stepFormValues?.companyId ? stepFormValues?.companyId : ""
                  }
                  options={companyDetails}
                />
                {typeof stepFormErrors?.companyId !== "undefined" &&
                  stepFormErrors?.companyId !== "" && (
                    <span className="d-flex small error color-danger">
                      {stepFormErrors?.companyId}
                    </span>
                  )}
              </div>
            ) : null} */}
            <div className="formFieldwrap">
              <Typography variant="body" className={`${styles.labelSm} dark:text-white`}>
                TimeZone
              </Typography>
              <div>
                <SingleSelectNew
                  id="timeZone"
                  contentClass="bg-white text-black border-gray-300 dark:bg-[#2c3440] dark:text-white dark:border-[#464c59]"
                  itemClass="hover:bg-gray-100 dark:hover:bg-[#3c4351]"
                  placeholder="TimeZone *"
                  value={stepFormValues?.timeZone}
                  onChange={handleSingleSelectChange("timeZone")}
                  options={selectedValues}
                />
              </div>
              {typeof stepFormErrors?.timeZone !== "undefined" &&
                stepFormErrors?.timeZone !== "" && (
                  <span className="small error color-danger">
                    {stepFormErrors?.timeZone}
                  </span>
                )}
            </div>
            <div className="formFieldwrap">
              <Typography variant="body" className={`${styles.labelSm} dark:text-white`}>
                Is Manager
              </Typography>
              <div>
                <SingleSelectNew
                  contentClass="bg-white text-black border-gray-300 dark:bg-[#2c3440] dark:text-white dark:border-[#464c59]"
                  itemClass="hover:bg-gray-100 dark:hover:bg-[#3c4351]"
                  id="isManager"
                  placeholder="Is Manager"
                  value={
                    stepFormValues?.isManager
                      ? stepFormValues?.isManager
                      : "false"
                  }
                  onChange={handleSingleSelectChange("isManager")}
                  options={[
                    { label: "Yes", value: "true" },
                    { label: "No", value: "false" },
                  ]}
                />
              </div>
            </div>
          </div>
        </CardContent>
      </Card>

      {editData?.pendingEmail && editData?.pendingEmail !== null && (
        <p className="mt-10 mb-20 text-[15px] font-medium text-orange-600 dark:text-orange-600"> 
          To complete your email update, please check your email{" "}
          <span className="font-semibold ml-1">({editData?.pendingEmail})</span>{" "}
          to verify your new email address. We will proceed with the update once verification is confirmed.</p>
      )}

      {(!isEdit && companyEmployee) ? 
          <div className="d-flex flex-justify-center color-danger mb-20" style={{fontSize:"16px", fontWeight:"500"}}>
        You have reached the maximum number of users allowed on your plan. To add more users, please&nbsp;
        <a
          href="/account/upgrade"
          style={{
            color: "#16A34A",
            textDecoration: "underline",
            cursor: "pointer",
          }}
        >
          upgrade your plan.
        </a>
          </div>
      : null}
      <div className="buttonsWrap d-flex flex-space-between flex-center">
        <DialogComponent
          buttonWrapClassName="d-inline"
          buttonClassName="bg-white dark:bg-gray-800"
          buttonProps={{
          variant: "outline",
          disabled: finalLoading === true ? true : false,
          }}
          buttonLabel={"Cancel"}
          ModalTitle={"Are you sure you want to cancel this entry?"}
          ModalContent={
            <ConfirmCancel isEdit={isEdit} onCancelAll={onCancelAll} />
          }
        />
        <Button
          variant={"contained"}
          className="bg-green-600 hover:bg-green-700 color-white"
          onClick={() => props?.validateAndGoNext()}
          disabled={(!isEdit && companyEmployee) || finalLoading === true ? true : false}
        >
          {finalLoading === true ? "Loading..." : "Save & Proceed"}
        </Button>
      </div>
    </>
  );
};

export default StepProfile;
